export const iconFontAwesomeHumanitarianWheelchairMove = (
	<i className="fa-solid fa-wheelchair-move"></i>
);
